/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('MemberManagementSearch', MemberManagementSearch);

    MemberManagementSearch.$inject = ['$resource'];

    function MemberManagementSearch($resource) {
        var resourceUrl =  'api/_search/profiles_guest/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
